import React from 'react'
import { FullBlockLoader, CircleLoader } from '@deal/components'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'
import V2 from './v2'
import {
  ProductRecommendedExpertCalloutComponent,
  FindExpertCalloutComponent
} from '#src/generated/graphql'

interface ExpertCalloutWithQueriesProps {
  categorySlug: string
  placement: 'department' | 'product'
  maybeExpertId?: string
  categoryId?: string
}

const ExpertCalloutWithQueries: React.SFC<
  ExpertCalloutWithQueriesProps & WithIdentityProps & WithAnalyticsProps
> = ({ maybeExpertId, children, categorySlug, categoryId, myself, placement, ...props }) => {
  if (!myself) {
    return null
  }

  if (maybeExpertId) {
    return (
      <FindExpertCalloutComponent variables={{ vanityIdOrId: maybeExpertId }}>
        {({ data, loading }) => {
          if (loading) {
            return <FullBlockLoader loader={CircleLoader} />
          } else if (data && data.findExpert) {
            const expertDepartment = data.findExpert.department

            if (
              data.findExpert.expertAttributes &&
              data.findExpert.expertAttributes.placeholderExpert
            ) {
              return null
            }

            return (
              <V2
                expertDepartment={expertDepartment}
                placement={placement}
                expertCalloutExpert={data.findExpert}
                categorySlug={categorySlug}
                {...props}
              />
            )
          }

          return null
        }}
      </FindExpertCalloutComponent>
    )
  } else if (categoryId) {
    return (
      <ProductRecommendedExpertCalloutComponent variables={{ consumerId: myself.id, categoryId }}>
        {({ data, loading }) => {
          if (loading) {
            return <FullBlockLoader loader={CircleLoader} />
          } else if (data && data.recommendExpert2 && data.recommendExpert2.expert) {
            const expertDepartment = data.recommendExpert2.expert.department

            if (
              data.recommendExpert2.expert.expertAttributes &&
              data.recommendExpert2.expert.expertAttributes.placeholderExpert
            ) {
              return null
            }

            return (
              <V2
                expertDepartment={expertDepartment}
                placement={placement}
                expertCalloutExpert={data.recommendExpert2.expert}
                categorySlug={categorySlug}
                {...props}
              />
            )
          }

          return null
        }}
      </ProductRecommendedExpertCalloutComponent>
    )
  } else {
    throw new Error('Category ID or expert ID are required to render callout')
  }
}

export default withIdentity(withAnalytics(ExpertCalloutWithQueries))
